import {getUserData} from "@/auth/utils";
import useJwt from "@/auth/jwt/useJwt";
import {initialAbility} from "@/libs/acl/config";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import rawAxiosInstance from "@/libs/rawAxiosInstance";

function convertNumbers2English(number) {
    if (number) {
        return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
            return c.charCodeAt(0) & 0xf;
        });
    }
}

async function processPayloadsRecursively(payloads) {
    if (!payloads) return;

    if (Array.isArray(payloads)) {
        for (const payload of payloads) {
            await processPayload(payload);
        }
    } else {
        await processPayload(payloads);
    }
}

async function processPayload(payload) {
    try {
        if (payload instanceof FormData) {
            return;
        } else if (Array.isArray(payload)) {
            await processPayloadsRecursively(payload);
        } else if (typeof payload === "object") {
            Object.keys(payload).forEach((item) => {
                if (typeof payload[item] === "object") {
                    processPayloadsRecursively(item);
                    return;
                } else if (typeof payload[item] === "string") {
                    payload[item] = convertNumbers2English(payload[item]);
                } else {
                    payload[item] = convertNumbers2English(payload[item].toString());
                    return;
                }
            });
        }
    } catch (error) {
        console.error(error);
    }
}

class WebServiceRequestForBlog {
    static baseUrl = 'https://ticketapi.ferman.org/api/v1/'

    constructor(context) {
        this.context = context;
        this.data = {
            meta: {},
            request: {},
        };
        this.queryUrl = {};

        let userToken = null;
        if (getUserData() && getUserData().token) {
            userToken = getUserData().token;
            this.userToken = userToken;
            rawAxiosInstance.defaults.headers.common["Authorization"] = userToken;
        }
        rawAxiosInstance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    }

    getData() {
        return this.data;
    }

    setTag(tag) {
        this.tag = tag;
    }

    setMethod(method) {
        this.method = method;
    }
    getMethod() {
      return  this.method;
    }

    getTag() {
        return this.tag;
    }

    setRequestParam(value) {
        let tempVal = JSON.parse(JSON.stringify(value));
        if (tempVal) {
            Object.keys(tempVal).forEach((item) => {
                if (item && tempVal[item]) {
                    tempVal[item] = convertNumbers2English(tempVal[item].toString());
                }

                if (
                    !tempVal[item] &&
                    tempVal[item] !== false &&
                    tempVal[item] !== 0 &&
                    tempVal[item] !== "0"
                ) {
                    delete tempVal[item];
                }
            });
        }
        this.queryUrl = tempVal;
    }

    convertDataToQueryString() {
        return Object.keys(this.queryUrl)
            .map((key) => key + "=" + this.queryUrl[key])
            .join("&");
    }

    setMetaParam(key, value) {
        this.data.meta[key] = value;
    }

    setRequestParamDataObj(value) {
        let deepCloned = JSON.parse(JSON.stringify(value));
        Object.keys(deepCloned).forEach((item) => {
            if (
                !deepCloned[item] &&
                deepCloned[item] !== false &&
                deepCloned[item] !== 0
            ) {
                delete deepCloned[item];
            }
        });
        processPayloadsRecursively(deepCloned);
        this.data = deepCloned;
    }

    setFormData(data) {
        this.formData = data;
    }

    getFormData() {
        return this.formData;
    }

    getUrl() {
        if (Object.keys(this.queryUrl).length > 0) {
            let query_string = this.convertDataToQueryString();
            return WebServiceRequestForBlog.baseUrl + this.tag + "?" + query_string;
        } else {
            return `${WebServiceRequestForBlog.baseUrl}${this.getTag()}`;
        }
    }

    async fetch(successCallback, errorCallback) {
        const _this = this;
        try {
            const response = await rawAxiosInstance({
                method: _this.getMethod() ?_this.getMethod() : 'POST' ,
                url: _this.getUrl(),
                data: JSON.stringify(_this.getData()),
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "X-User-Id": getUserData().user.userId,
                    "X-User-Roles": 'Admin',
                    Authorization: _this.userToken,
                    platform: "Web",
                },
            });

            if (response.status === 422) {
                _this.context.$toast({
                    component: ToastificationContent,
                    position: "bottom-center",
                    props: {
                        title: `توجه`,
                        icon: "",
                        variant: "danger",
                        text: `دسترسی شما به این صفحه محدود می باشد.`,
                    },
                });
                return;
            }

            if (response.status === 401) {
                localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
                localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
                localStorage.removeItem("userData");
                _this.context.$ability.update(initialAbility);
                _this.context.$router.push({name: "auth-login"});
            }

            if (response.status === 500) {
                _this.context.$toast({
                    component: ToastificationContent,
                    position: "bottom-center",
                    props: {
                        title: `توجه`,
                        icon: "",
                        variant: "danger",
                        text: `مشکلی در سرور رخ داده است لطفا بعدا تلاش کنید.`,
                    },
                });
            }

            if (successCallback) {
                successCallback(response.data);
            }
        } catch (error) {
            if (errorCallback) {
                errorCallback(error);
            }
            console.error(error);
        }
    }

    async sendFormData(successCallback, errorCallback) {
        const _this = this;

        try {
            const response = await rawAxiosInstance.post(_this.getUrl(), _this.getFormData(), {
                onUploadProgress: (progressEvent) => {
                    if (_this.context) {
                        _this.context.uploaded = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                    }
                },
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: _this.userToken,
                    platform: "Web",
                },
            });

            if (successCallback) {
                successCallback(response);
            }
        } catch (error) {
            if (errorCallback) {
                errorCallback(error);
            }
            console.error(error);
        }
    }
}

export default WebServiceRequestForBlog;
